import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core';
import { CookieService } from 'src/app/customServices/cookie.service';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';
import { AddressSelectPopupComponent } from '../address-select-popup/address-select-popup.component';
import { VorOrderPopupComponent } from '../vor-order-popup/vor-order-popup.component';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { GeneralConditionsComponent } from '../../kb-register/general-conditions/general-conditions.component';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { RegisterService } from 'src/app/services/feature/register.service';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';

@Component({
  selector: 'app-kbcheckoutstepper',
  templateUrl: './kbcheckoutstepper.component.html',
  styleUrls: ['./kbcheckoutstepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class KbcheckoutstepperComponent {
  @Input() thirdStep: any;
  @Input() stepTwo: any;
  showAddAddress: boolean = false;
  isTermsChecked: boolean;
  stateList: any;

  thirdFormGroup = this._formBuilder.group({
    companyName: ['', Validators.required],
    address: ['', Validators.required],
    houseNumber: [''],
    address2: [''],
    state: [null, Validators.required],
    city: ['', Validators.required],
    postalCode: ['', Validators.required],
    country: [null, Validators.required],
  });
  fourthFormGroup: FormGroup;

  @ViewChild('stepper') stepper: MatStepper;


  @Input()
  steponeOrg: any;
  stepone: any;



  steponeCompleted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  stepTwoCompleted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  stepThreeCompleted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input()
  userInWhichStep: number;
  @Input()
  currentCartId: any;


  matDataDialog;

  stepFourData: any;
  canPlaceOrder: boolean;
  OrderNotesText: string;
  carrierAccFlag: boolean = false;
  errorMessage: any;
  timezoneMsg: string;
  carrierType: any;
  orderNote: string;
  CarrierNumber: any;
  purchaseOrderNumber: string = '';

  //statemaintain bugs from mat ui temporary fixes as boolean recalling api
  postSteptwo: boolean = true;
  poststepthree: boolean = true;
  showNetPrice$ = this.custIdService.showNetPrice$;

  firstFormGroup = new FormGroup({
    firstCtrl: new FormControl(null, [Validators.required]),
  });
  fleetPrideGroup: any;
  get firstForm() {
    return this.firstFormGroup.controls;
  }
  secondFormGroup = new FormGroup({
    carrierAccNumber: new FormControl(null),
    orderNotes: new FormControl(null),
    carrierType: new FormControl(null, [Validators.required]),
  });
  get secondForm() {
    return this.secondFormGroup.controls;
  }
  private destroy$ = new Subject<void>();
  @Input() currentB2bUnitSendToWebtrack: any;
  constructor(
    private _formBuilder: FormBuilder,
    private matdialog: MatDialog,
    private GlobalMsgService: GlobalMessageService,
    private kbCheckoutService: KbCheckOutService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private cookieService: CookieService,
    private translationService: TranslationService,
    private activeCartService: ActiveCartFacade,
    private dialog: MatDialog,
    private custIdService: CustomerIdService,
    private registerService: RegisterService,
    private cdf: ChangeDetectorRef,
    private cartTrackingService: CartTrackingService,
  ) { }

  ngOnInit() {
    if (this.userInWhichStep == 1) {
      this.steponeCompleted.next(true);

      this.cdr.detectChanges();
    }
    if (this.userInWhichStep == 2) {
      this.steponeCompleted.next(true);
      this.stepTwoCompleted.next(true);
      this.cdr.detectChanges();
    }
    if (this.userInWhichStep == 3) {
      this.steponeCompleted.next(true);
      this.stepTwoCompleted.next(true);
      this.stepThreeCompleted.next(true);
      this.postStepThreeData(this.currentCartId);
    }
    this.custIdService.fleetPrideGroup$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.fleetPrideGroup = x;
      this.cdr.detectChanges();
    })
    this.cdr.detectChanges();
  }

  openDialog(address: any, cartId?: string, whichStep?: boolean) {
    const dialogRef = this.matdialog.open(AddressSelectPopupComponent, {
      data: { whichStep, address },
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        //step1
        if (!this.steponeCompleted.value) {
          this.matDataDialog = data;
          this.updateBillingAddress();
        } else {
          //step3
          this.kbCheckoutService
            .useAddress(cartId, data.id)
            .pipe(takeUntil(this.destroy$)).subscribe((res) => {
              this.thirdStep = res;
              this.cdr.detectChanges();
            });
        }
      }
    });
  }

  postStepOneData() {
    if (this.firstFormGroup.valid) {
      let poNumber: string | null = null;
      poNumber = this.firstForm.firstCtrl.value;
      // ✅ Encode special characters
      if (poNumber) {
        poNumber = encodeURIComponent(poNumber);
      }
      this.kbCheckoutService
        .postApiCallForStepOne(
          poNumber,   // ✅ send encoded value
          this.matDataDialog?.id
        )
        .pipe(takeUntil(this.destroy$)).subscribe((x) => {
          if (x?.['kbStatusMessage']['status'] == 'ERROR') {
            this.globalMessageService.add(
              { key: x?.['kbStatusMessage']['message'] },
              GlobalMessageType.MSG_TYPE_ERROR
            );
          } else {
            this.steponeCompleted.next(true);
            this.cartTrackingService.trackCheckoutStep(
              this.currentCartId,
              '1_Customer_Information',
              this.currentB2bUnitSendToWebtrack
            );
            this.cookieService.setItemSessionStorage(
              'userInwhichStep',
              1
            );
            this.stepper.next();
            this.kbCheckoutService.activeStep.next(2);
          }
        });
    } else {
      const status = {
        message: 'common.checkout_error_paymenttype_formentry_invalid',
      };
      this.GlobalMsgService.add(
        { key: status?.message },
        GlobalMessageType.MSG_TYPE_ERROR
      );
      this.firstFormGroup.markAllAsTouched();
    }
  }

  initializeStepTwoForm() {
    // this.countryIsoCode = this.cookieService.getCookieValue('countryIsoCode');
    this.translationService
      .translate('common.checkout_page_DeliveryMethodForOrder_NA_orderNote')
      .pipe(takeUntil(this.destroy$)).subscribe((key) => {
        const labelContent = key;
        this.OrderNotesText = this.splitLabel(labelContent);
      });


    //Load carrierType
    this.secondForm.carrierType.patchValue(this.stepTwo?.currentCarrierType ?? null);


    //Load CarrierNumber
    this.secondForm.carrierAccNumber.patchValue(this.stepTwo?.currentCarrierNumber ?? null);


    //Load OrderNote
    this.secondForm.orderNotes.patchValue(this.stepTwo?.orderNote ?? null);


  }
  postStepTwoData() {
    let isFormValid: boolean = true;
    if (this.isEMGY() || this.isSHFD()) {
      isFormValid = this.secondFormGroup.valid;
    }

    if (isFormValid) {

      let orderNoteVal: any;
      if (this.secondForm.orderNotes.value == undefined || this.secondForm.orderNotes.value == null) {
        orderNoteVal = '';
      }
      else {
        orderNoteVal = this.secondForm.orderNotes.value;
      }
      this.kbCheckoutService
        .postApiCallForStepTwo(
          this.secondForm.carrierType.value,
          orderNoteVal.trim(),
          this.secondForm.carrierAccNumber.value.trim()
        )
        .pipe(takeUntil(this.destroy$)).subscribe((x) => {
          if (x?.['status'] == 'ERROR') {
            this.carrierAccFlag = true;
            this.errorMessage = x?.['message2'];
            this.globalMessageService.add(
              x?.['message'],
              GlobalMessageType.MSG_TYPE_ERROR
            );
            this.cdr.detectChanges();

          } else {
            this.stepTwoCompleted.next(true);
            this.cartTrackingService.trackCheckoutStep(this.currentCartId, '2_Delivery_Options', this.currentB2bUnitSendToWebtrack);
            this.carrierAccFlag = false;
            this.cookieService.setItemSessionStorage('userInwhichStep', 2);
            this.stepper.next();
            this.kbCheckoutService.activeStep.next(3);
            this.cdr.detectChanges();

          }
          if (this.postSteptwo) {
            this.postStepTwoData();
            this.postSteptwo = false;
          }

        });
    } else {
      this.secondFormGroup.markAllAsTouched();
    }
  }

  splitLabel(text: string): string {
    // Use regex to split text at "<br />" tag
    const regex = /<br\s*\/?>/i;
    const parts = text.split(regex);
    return parts.join('\n'); // Join parts with newline character
  }

  saveAddress(cartId) {
    if (!this.thirdFormGroup.valid) {
      this.globalMessageService.add(
        { key: 'common.address_error_formentry_invalid' },
        GlobalMessageType.MSG_TYPE_ERROR
      );
    } else {
      const payload = {
        firstName: '',
        lastName: '',
        TitleCode: '',
        companyName: this.thirdFormGroup.controls['companyName'].value,
        line1: this.thirdFormGroup.controls['address'].value,
        line2: this.thirdFormGroup.controls['houseNumber'].value,
        postalCode: this.thirdFormGroup.controls['postalCode'].value,
        town: this.thirdFormGroup.controls['city'].value,
        phone: '',
        companyAddressTwo: this.thirdFormGroup.controls['address2'].value,
        country: {
          isocode: this.thirdFormGroup.controls['country'].value,
        },
        region: {
          isocode: this.thirdFormGroup.controls['state'].value,
        },
      };
      this.kbCheckoutService
        .saveNewAddress(payload, cartId)
        .pipe(takeUntil(this.destroy$)).subscribe((data) => {
          this.thirdStep = data;
          this.showAddAddress = false;
          this.cdr.detectChanges();
        });
    }
  }
  updateBillingAddress() {
    if (this.steponeOrg.paymentAddress) {
      this.stepone.paymentAddress = this.matDataDialog;
      this.cdr.detectChanges();
    }
    if (this.steponeOrg.defaultBilling) {
      this.stepone.defaultBilling = this.matDataDialog;
      this.cdr.detectChanges();
    }
  }

  postStepThreeData(cartId) {
    this.kbCheckoutService.getReviewData(cartId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data) {
        if (data.listEmergencyOrderWithoutStock && data.listEmergencyOrderWithoutStock.length > 0) {
          this.openVORDialog(data);
        }
        if (data.emergencyNote?.note && data.emergencyNote?.note.errorValue1) {
          this.translationService
            .translate(data.emergencyNote?.note.message)
            .pipe(takeUntil(this.destroy$)).subscribe((val) => {
              this.timezoneMsg = val.replace("{1}", data.emergencyNote.note.errorValue2).replace("{2}", data.emergencyNote.note.errorValue3)
            })
        }
        this.stepFourData = data;
        this.cookieService.setItemSessionStorage('userInwhichStep', 3);
        this.kbCheckoutService.activeStep.next(4);
        this.stepThreeCompleted.next(true);
        this.cartTrackingService.trackCheckoutStep(this.currentCartId, '3_Shipping_Address', this.currentB2bUnitSendToWebtrack);
        this.kbCheckoutService.finalOrderSummaryRight.next(data);
        this.stepper.next();
        this.cdr.detectChanges();
      }
      if (this.poststepthree) {
        this.postStepThreeData(this.currentCartId);
        this.poststepthree = false;
      }
    });
  }

  placeOrder(cartId) {
    this.kbCheckoutService.placeOrder(cartId).pipe(takeUntil(this.destroy$)).subscribe((item) => {
      if (item?.['status'] == 'SUCCESS') {
        this.cartTrackingService.trackCheckoutStep(this.currentCartId, '4_Final_Order', item?.['orderCode'], this.currentB2bUnitSendToWebtrack);
        this.cookieService.setItemSessionStorage('userInwhichStep', 0);
        this.activeCartService.reloadActiveCart();
        this.router.navigate(['orderconfirmation'], {
          queryParams: { orderId: item?.['orderCode'] },
        });
      }
      else {
        this.globalMessageService.add(
          { key: item?.['checkoutValidationErrorMessage'] },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    });
  }

  placeOrderCheck(ev) {
    this.canPlaceOrder = ev.target.checked;
  }

  setActiveStep(val) {
    this.kbCheckoutService.activeStep.next(val);
  }
  selectionChange(val) {
    this.setActiveStep(val?.selectedIndex + 1);
  }
  ngOnChanges() {
    this.stepone = this.steponeOrg;
    if (this.steponeOrg?.purchaseOrderNumber !== undefined) {
      this.firstForm.firstCtrl.patchValue(this.steponeOrg?.purchaseOrderNumber ?? null)
    }
    //checking and setting state for stepTwo
    this.initializeStepTwoForm();
  }

  isSTOR(): any {
    return this.stepTwo?.selectedOrderTypeCode == 'STOR';
  }
  isEMGY(): any {
    return this.stepTwo?.selectedOrderTypeCode == 'EMGY';
  }
  isSHFD(): any {
    return this.stepTwo?.selectedOrderTypeCode == 'SHFD';
  }

  openVORDialog(orderList) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = orderList;
    dialogConfig.panelClass = 'vor-order-popup';

    const dialogRef = this.dialog.open(VorOrderPopupComponent, dialogConfig);
  }

  openGeneralConditions() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    const dialogRef = this.dialog.open(
      GeneralConditionsComponent,
      dialogConfig
    );
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.canPlaceOrder = true;
        this.isTermsChecked = true;
        this.cdr.detectChanges();
      }
    });
  }

  getStateList() {
    this.registerService.getRegions(this.thirdFormGroup.controls['country'].value).pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe((item: any) => {
      this.stateList = item?.regionsWSList;
      this.cdf.detectChanges();
    })
  }
  ngOnDestroy() {
    this.kbCheckoutService.activeStep.next(1);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
